import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PHK3({ floorNumber }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };
    if (isMobile && isClicked) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true);
        setIsClicked(true);
      } else {
        navigate('/navigate-floor', {
          state: {
            customUrl1: '',
            customUrl2: 'PH-K3',
            vrPath: 'https://hitimperial.github.io/VR360-3-4/Penthouse-K3/',
            customUrl3: floorNumber || '13',
            images: ['/images/Bazat 2D dhe 3D k3&4/L3/L3 - PH-1.jpg'],
          },
        });
      }
    } else {
      navigate('/navigate-floor', {
        state: {
          customUrl1: '',
          customUrl2: 'PH-K3',
          vrPath: 'https://hitimperial.github.io/VR360-3-4/Penthouse-K3/',
          customUrl3: floorNumber || '13',
          images: ['/images/Bazat 2D dhe 3D k3&4/L3/L3 - PH-1.jpg'],
        },
      });
    }
  };

  return (
    <>
      {/* PNG overlay - mbulon të gjithë imazhin për pozicionim korrekt */}
      <img
        className={`absolute top-0 left-0 w-full h-auto transition-opacity duration-300 pointer-events-none ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}
        src="/images/click/clickable-images/Floors/Direct-floors/clickable-floors3&4/PenthouseFloor/PH-K3-Klikimi.png"
        alt="Penthouse K3"
      />
      {/* Zona e klikimit - mbulon vetëm gjysmën e majtë */}
      <div
        ref={imageRef}
        className="absolute top-0 left-0 w-[50%] h-full cursor-pointer"
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => !isMobile && setIsHovered(false)}
        onClick={handleClick}
      />
    </>
  );
}
